import React from 'react';
import LocationTemplate from './LocationTemplate';

const ErwinPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Erwin"
      stateName="North Carolina"
      countyName="Harnett"
      zipCodes={["28339"]}
      latitude={35.3249}
      longitude={-78.6758}
      population={5101}
      historicalFact="Formerly called Duke, renamed after the textile mill owner."
      nearbyTowns={[
        "Dunn, NC",
        "Coats, NC",
        "Benson, NC",
        "Angier, NC",
        "Lillington, NC",
        "Fayetteville, NC",
        "Buies Creek, NC",
        "Fuquay-Varina, NC"
      ]}
    />
  );
};

export default ErwinPage;